import { Answer, Question, Response } from "../types";

export function isMultiTextResponse(
  response: Response
): response is MultiTextResponse {
  return response.type === "multitext";
}

export class MultiTextQuestion<S = unknown> implements Question<string[]> {
  type = "multitext" as const;

  statement: S;

  constructor(statement: S) {
    this.statement = statement;
  }

  getValue(answer: Answer) {
    if (!isMultiTextResponse(answer.response)) {
      throw new Error("Expected MultiChoiceInputResponse");
    }

    const { choices } = answer.response;

    return choices;
  }
}

export type MultiTextResponse = {
  type: "multitext";
  choices: string[];
};

export function createMultiTextAnswer(
  choices: string[]
): Answer<MultiTextResponse> {
  return {
    response: {
      type: "multitext",
      choices,
    },
  };
}
